import { Component, Input, OnInit } from '@angular/core';
import { faHeart } from '@fortawesome/free-solid-svg-icons';
import { faHeart as faHeartRegular } from '@fortawesome/free-regular-svg-icons';
import { AppConstants } from 'src/app/core/constants';
import { CarService } from 'src/app/core/services/car.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-shortlist-button',
  templateUrl: './shortlist-button.component.html',
  styleUrls: ['./shortlist-button.component.scss',],
})
export class ShortlistButtonComponent implements OnInit {

  faHeart = faHeart;
  faHeartRegular = faHeartRegular;

  @Input() carId!: string;
  isShortlisted: boolean = false;
  shortlistedCars: string[] = [];

  constructor(
    private _router: Router,
    private _authService: AuthService,
    private _carService: CarService
  ) { }

  ngOnInit(): void {
    const localCars = localStorage.getItem(AppConstants.SHORTLISTED_CARS_KEY);
    if (localCars) {
      this.shortlistedCars = JSON.parse(localCars);
    }
    this.checkIsShortlisted();
  }

  checkIsShortlisted() {
    this.isShortlisted = this.shortlistedCars.includes(this.carId);
  }

  toggleShortlist() {
    if (!this._authService.getToken()) {
      this._router.navigateByUrl('auth');
      return;
    }
    const index = this.shortlistedCars.indexOf(this.carId);
    if (index > AppConstants.NEGATIVE_ONE) this.shortlistedCars.splice(index, AppConstants.ONE);
    else this.shortlistedCars.push(this.carId);
    this.checkIsShortlisted();
    localStorage.setItem(AppConstants.SHORTLISTED_CARS_KEY, JSON.stringify(this.shortlistedCars));

    this._carService.updateShortlisted(this.carId).subscribe({
      next: (_data) => {
        // TODO show toast message
      },
    });
  }

}
